module.exports = __webpack_public_path__ + "static/media/wanderer.663dda7d.jpeg";